// Domain entities for the customer onboarding submission outcome.
// The backend (PATCH /customers/{businessKey}) always returns HTTP 200 with
// ApiResponse code="00"; the business nuance lives entirely in `data`
// (CustomerSubmissionResponse). The frontend routes on `submissionOutcome`
// (machine state) and renders title/message/instructions verbatim.

/** Global result of the submission. */
export enum SubmissionOutcome {
  ACCOUNT_CREATED = "ACCOUNT_CREATED",
  REGISTERED_PENDING_REVIEW = "REGISTERED_PENDING_REVIEW",
  REFUSED_SANCTIONS = "REFUSED_SANCTIONS",
  SCREENING_IN_PROGRESS = "SCREENING_IN_PROGRESS",
}

/** Review lane opened by compliance, when applicable. */
export enum ReviewTrack {
  EDD_4EYES = "EDD_4EYES",
  L1_REVIEW = "L1_REVIEW",
  P4 = "P4",
}

/** Machine routing hint for the frontend. */
export enum NextStepHint {
  NONE = "NONE",
  EDD_APPROVAL_REQUIRED = "EDD_APPROVAL_REQUIRED",
  L1_AUTHORIZATION_REQUIRED = "L1_AUTHORIZATION_REQUIRED",
  WAIT_WEBHOOK = "WAIT_WEBHOOK",
  WAIT_SCREENING = "WAIT_SCREENING",
  CONTACT_COMPLIANCE = "CONTACT_COMPLIANCE",
}

export interface CustomerSubmissionResponse {
  businessKey: string;
  submissionOutcome: SubmissionOutcome;
  customerStatus: string;
  accountCreated: boolean;
  accountNumber: string | null;
  customerCode: string | null;
  /**
   * Review/refusal motive. Open-ended string (e.g. PEP_REVIEW_REQUIRED,
   * HIGH_RISK_REVIEW_REQUIRED, TRACK_A_SANCTIONS_HIT, …) — kept as a raw
   * string so new backend values still type-check.
   */
  blockingReason: string | null;
  reviewTrack: ReviewTrack | null;
  /** Short title, pre-written by the backend (display verbatim). */
  title: string;
  /** Human-readable explanation, 1–2 sentences (display verbatim). */
  message: string;
  /** Steps to follow, rendered as a bullet list (display verbatim). */
  instructions: string[];
  nextStepHint: NextStepHint;
  /** True when the dossier can be re-opened for study (REFUSED cases). */
  reopenable: boolean;
}
